module.exports = __webpack_public_path__ + "static/media/setup_org_tree.73699fca.webp";